window.addEventListener("DOMContentLoaded", function () {
  initMemberStepGiftCartPosition();
});

function initMemberStepGiftCartPosition() {
  const desktopQuery = window.matchMedia("(min-width: 1440.1px)");
  const cart = document.querySelector(".member-step-gift-cart");
  const startAnchor = document.querySelector(
    ".world-cup-2026-champion-picks .p-sale-swiper-groups-wrapper"
  );
  const stopAnchor = document.querySelector(".world-cup-2026-terms");

  if (!cart || !startAnchor || !stopAnchor) return;

  let ticking = false;
  let cartHeight = 0;
  let startTop = 0;
  let stopTop = 0;
  let fixedOffset = 0;
  let mobileShowOffset = 0;
  let lastWindowWidth = window.innerWidth;

  function getPageTop(element) {
    return element.getBoundingClientRect().top + window.scrollY;
  }

  function resetCartPosition() {
    cart.style.position = "";
    cart.style.top = "";
    cart.style.bottom = "";
    cart.style.zIndex = "";
    cart.style.transform = "";
    cart.style.transition = "";
  }

  function clearCartPosition() {
    resetCartPosition();
    cart.dataset.stickyState = "";
  }

  function measure() {
    const previousPosition = cart.style.position;
    const previousTop = cart.style.top;
    const previousBottom = cart.style.bottom;
    const previousZIndex = cart.style.zIndex;
    const previousTransform = cart.style.transform;
    const previousTransition = cart.style.transition;

    resetCartPosition();

    const cartRect = cart.getBoundingClientRect();
    cartHeight = cart.offsetHeight;
    startTop = getPageTop(startAnchor);
    stopTop = getPageTop(stopAnchor);
    fixedOffset = window.innerHeight / 3;
    mobileShowOffset = (window.innerHeight * 2) / 3;

    cart.style.position = previousPosition;
    cart.style.top = previousTop;
    cart.style.bottom = previousBottom;
    cart.style.zIndex = previousZIndex;
    cart.style.transform = previousTransform;
    cart.style.transition = previousTransition;

    updatePosition();
  }

  function setDesktopAbsolute(top) {
    cart.style.position = "absolute";
    cart.style.top = `${top}px`;
    cart.style.bottom = "";
    cart.style.zIndex = "1000000";
    cart.style.transform = "";
    cart.style.transition = "";
  }

  function setDesktopFixed() {
    cart.style.position = "fixed";
    cart.style.top = `${fixedOffset}px`;
    cart.style.bottom = "";
    cart.style.zIndex = "1000000";
    cart.style.transform = "";
    cart.style.transition = "";
  }

  function setMobileFixed(isVisible) {
    cart.style.position = "fixed";
    cart.style.top = "";
    cart.style.bottom = "0";
    cart.style.zIndex = "10";
    cart.style.transition = "transform 0.3s ease";
    cart.style.transform = isVisible ? "translateY(0)" : "translateY(100%)";
    cart.dataset.stickyState = isVisible ? "mobile-fixed" : "mobile-hidden";
  }

  function updateDesktopPosition(fixedTopOnPage) {
    const stopCartTop = stopTop - cartHeight;

    if (fixedTopOnPage < startTop) {
      cart.dataset.stickyState = "start";
      setDesktopAbsolute(startTop);
      return;
    }

    if (fixedTopOnPage + cartHeight >= stopTop) {
      cart.dataset.stickyState = "end";
      setDesktopAbsolute(Math.max(startTop, stopCartTop));
      return;
    }

    cart.dataset.stickyState = "fixed";
    setDesktopFixed();
  }

  function updateMobilePosition(fixedTopOnPage) {
    const showLineOnPage = window.scrollY + mobileShowOffset;
    const shouldShow = showLineOnPage >= startTop && fixedTopOnPage < stopTop;

    setMobileFixed(shouldShow);
  }

  function updatePosition() {
    ticking = false;

    if (!cartHeight || stopTop <= startTop) {
      cart.dataset.stickyState = "disabled";
      clearCartPosition();
      return;
    }

    const fixedTopOnPage = window.scrollY + fixedOffset;

    if (desktopQuery.matches) {
      updateDesktopPosition(fixedTopOnPage);
      return;
    }

    updateMobilePosition(fixedTopOnPage);
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updatePosition);
  }

  function handleResize() {
    if (window.innerWidth === lastWindowWidth) return;

    lastWindowWidth = window.innerWidth;
    measure();
  }

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", handleResize);
  window.addEventListener("load", measure);

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener("change", measure);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(measure);
  }

  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(cart);
  }

  measure();
}
